<cerrix-icon-button
    [attr.data-uiid]="'linked-item-open-' + itemLabel"
    icon="link-external"
    [showBorder]="false"
    [disabled]="disabled"
    [ariaLabel]="'open' | t: { item: itemLabel }"
    (click)="open.emit()"
/>
@if (canUnlink) {
    <cerrix-icon-button
        [attr.data-uiid]="'linked-item-unlink-' + itemLabel"
        icon="unlink"
        [showBorder]="false"
        [disabled]="disabled"
        [ariaLabel]="'unlink' | t: { item: itemLabel }"
        (click)="unlink.emit()"
    />
}
